// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"dece8fd7","938":"8b09a32f","943":"266f1696"}[chunkId] + ".chunk.css";
};